import { useSiteContent } from "@/context/SiteContentContext";

export const CURATED_KEYS = {
  visible: "curated_drop.visible",
  label: "home.hero_kicker",
  heading: "home.hero_headline",
  description: "home.hero_subtext",
  logo: "curated_drop.logo",
  vendorText: "curated_drop.vendor_text",
  logoPosition: "curated_drop.logo_position",
  logoSize: "curated_drop.logo_size",
};

export default function CuratedDropSection() {
  const { content } = useSiteContent();
  if (!Object.keys(content).length || content[CURATED_KEYS.visible] === "false") return null;
  const label = content[CURATED_KEYS.label] || "";
  const heading = content[CURATED_KEYS.heading] || "";
  const description = content[CURATED_KEYS.description] || "";
  const logo = content[CURATED_KEYS.logo] || "";
  const vendorText = content[CURATED_KEYS.vendorText] || "";
  const right = content[CURATED_KEYS.logoPosition] === "right";
  const size = Math.min(240, Math.max(40, Number(content[CURATED_KEYS.logoSize]) || 96));
  if (!label && !heading && !description && !logo && !vendorText) return null;

  return (
    <section className="mx-auto max-w-7xl px-4 lg:px-8 mt-6 sm:mt-8 md:mt-12" data-testid="curated-drop-section">
      <div className={`rounded-3xl bg-white border border-gray-200 p-4 sm:p-6 md:p-10 flex flex-col gap-4 md:gap-8 md:items-center ${right ? "md:flex-row-reverse" : "md:flex-row"}`}>
        {logo && (
          <img data-testid="curated-drop-logo" src={logo} alt="Exhibitor logo" style={{ width: size, height: size }}
            className="shrink-0 object-contain rounded-2xl border border-gray-100 bg-white" />
        )}
        <div className="min-w-0 flex-1">
          {label && <div data-testid="curated-drop-label" className="text-xs uppercase tracking-[0.3em] text-[#F48E2E] font-bold mb-2">{label}</div>}
          {heading && <h2 data-testid="curated-drop-heading" className="font-display text-3xl md:text-4xl mb-2">{heading}</h2>}
          {description && <p data-testid="curated-drop-description" className="text-gray-600 max-w-2xl">{description}</p>}
          {vendorText && <p data-testid="curated-drop-vendor-text" className="mt-3 text-sm text-gray-700 max-w-2xl whitespace-pre-line">{vendorText}</p>}
        </div>
      </div>
    </section>
  );
}
